import { api } from '@services';

import { IPaginationResult } from '@models/Equipment.model';
import EquipmentInventory, {
  IEquipmentInventory,
  IEquipmentInventoryApiModel,
} from '@models/EquipmentInventory.model';

export interface IFilterRequest {
  tagId: string;
  sort?: string;
  direction?: 'ASC' | 'DESC' | undefined;
}
export interface IPagination {
  page: number;
  limit: number;
  search?: string;
}
interface IRequest {
  pagination?: IPagination;
  filter: IFilterRequest;
}

export const getEquipmentsByTag = async ({
  pagination,
  filter,
}: IRequest): Promise<IPaginationResult<IEquipmentInventory>> => {
  const { data: equipments } = await api.get<
    IPaginationResult<IEquipmentInventoryApiModel>
  >(
    `/equipments?page=${pagination?.page || 1}&limit=${pagination?.limit || 9}${
      pagination?.search ? `&q=${pagination.search}` : ''
    }${filter?.sort ? `&sort=${filter.sort}` : ''}${
      filter?.direction ? `&direction=${filter.direction}` : ''
    }${filter?.tagId ? `&tagId=${filter.tagId}` : ''}
`,
  );

  return EquipmentInventory.fromArrayPaginatedApiModel(equipments);
};
